import React, { useContext, useState, useEffect } from 'react'

import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import InvoiceContext from '@/product/context/invoice/invoiceContext'
import CustomCommonContext from '@/custom/context/common/commonContext'

import {
    dateFormatFunction,
    dateTimeFormatFunction,
    currencyFormat,
    capitalize,
    paymentTypeRosoom,
} from '@/custom/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import CommonInvoiceView from '@/product/components/species/invoice/InvoiceCommonView'

const InvoiceView = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const { allConfigurationVariables } = customCommonContext

    const invoiceContext = useContext(InvoiceContext)
    const {
        single_invoice,
        getSingleInvoice,
        all_invoices,
        getMultipleInvoice,
        multiple_invoice,
    } = invoiceContext

    const [viewContent, setViewContent] = React.useState(null)
    const [invoiceDetails, setInvoiceDetails] = React.useState([])
    const [print, setPrint] = useState(false)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const formik = useFormik({
        initialValues: {
            cart_id: 0,
        },
        validateOnBlur: false,
    })

    // temp lang Manager

    useEffect(() => {
        resetFrom()
        setPrint(false)
    }, [props])

    useEffect(() => {
        if (data.status === 'print' && multiple_invoice.records.length) {
            setInvoiceDetails(multiple_invoice.records)
        } else if (
            data.status === 'multi_view' &&
            multiple_invoice.records.length
        ) {
            setInvoiceDetails(multiple_invoice.records)
        } else {
            setInvoiceDetails([])
        }
    }, [multiple_invoice])

    useEffect(() => {
        if (
            single_invoice?.invoicerecords?.length &&
            (data.status === 'view' || data.status === 'edit')
        ) {
            setInvoiceDetails(single_invoice)
        } else {
            setInvoiceDetails([])
        }
    }, [single_invoice])

    useEffect(() => {
        setInvoiceDetails([])
        if (data.status === 'edit' || data.status === 'view') {
            formik.values.invoice_id = data.id
            formik.values.user_id = data.sid
            if (data.action === 'cancel') {
                formik.values.filters = {
                    active: {
                        type: 'in',
                        field: 'b.active',
                        value: 2,
                    },
                }
            } else {
                formik.values.filters = {
                    active: {
                        type: 'notin',
                        field: 'b.active',
                        value: 2,
                    },
                }
            }
            getSingleInvoice(formik.values)
        } else if (data.status === 'print') {
            getMultipleInvoice({
                cart_id: 0,
                filters: {
                    active: {
                        type: 'notin',
                        field: 'b.active',
                        value: 2,
                    },
                },
                buynow_ids: data.id,
                user_id: 1,
            })
        } else if (props?.data?.status === 'multi_view') {
            getMultipleInvoice({
                cart_id: 0,
                filters: {
                    active: {
                        type: 'notin',
                        field: 'b.active',
                        value: 2,
                    },
                },
                buynow_ids: props.data.id,
                user_id: 1,
            })
        } else {
            resetFrom()
        }
    }, [data.id])

    const resetFrom = () => {
        setViewContent(null)
    }

    // useEffect(() => {
    //     if (data.popup && invoiceDetails.length && data.status === 'print') {
    //         setTimeout(() => {
    //             setPrint(true)
    //         }, 2000)
    //     } else {
    //         setPrint(false)
    //     }
    // }, [data, invoiceDetails])

    useEffect(() => {
        if (print) {
            window.print()
            closeFunction()
        }
    }, [print])

    const closeFunction = () => {
        toggleFullScreenPopup(false)
        setPrint(false)
        setInvoiceDetails([])
        props.updateFunction()
    }
    const updateFunction = () => {
        setPrint(true)
    }

    // const generatePDF = (toPdf) => {
    //     setPrint(true)
    //     toPdf()
    // }
    // const completedPDF = () => {
    //     setPrint(false)
    // }
    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'view' || data.status === 'multi_view'
                    ? `VIEW INVOICE`
                    : `EDIT INVOICE`
            }
            open={data.popup}
            handleClose={() => closeFunction()}
        >
            {invoiceDetails ? (
                data.status === 'print' && invoiceDetails.length ? (
                    invoiceDetails.map((item, index) => (
                        <CommonInvoiceView
                            print={print}
                            invoiceDetails={item}
                            status={'print'}
                            updateFunction={updateFunction}
                            orderControlLogs={true}
                            taxLabel={'Sales Tax'}
                        />
                    ))
                ) : data.status === 'multi_view' && invoiceDetails.length ? (
                    invoiceDetails.map((item, index) => (
                        <CommonInvoiceView
                            print={print}
                            invoiceDetails={item}
                            status={'multi_view'}
                            updateFunction={updateFunction}
                            orderControlLogs={true}
                            taxLabel={'Sales Tax'}
                        />
                    ))
                ) : (
                    <CommonInvoiceView
                        print={print}
                        invoiceDetails={invoiceDetails}
                        data={props.data.id}
                        status={'view'}
                        orderControlLogs={true}
                        taxLabel={'Sales Tax'}
                    />
                )
            ) : null}
        </FullScreenPopup>
    )
}

export default InvoiceView
